<template>
  <section class="container section-scc-portal">
    <b-alert
        :show="showMessage"
        :variant="typeColor"
        dismissible
        @dismissed="closeMessageBox"
    >
      <div class="span-login-page">
        {{ textMessage }}
      </div>
    </b-alert>

  </section>
</template>

<script>
export default {
  name: "messageBox",
  props: ['typeColor', 'textMessage', 'showMessage' ],
  data(){
    return {
      sectionTypeColor: 'danger',
      sectionTextMessage: '',
    }
  },
  mounted() {
    this.sectionTypeColor = this.typeColor
    this.sectionTextMessage = this.textMessage
  },
  methods: {
    closeMessageBox() {
      this.$root.$emit('closeMessageBox');
    }
  },
}
</script>

<style scoped>
.span-login-page{
  white-space: pre-wrap;
}
</style>
